'use strict';

import {
    AppDispatch,
    StoreState,
    Thunk
} from '~/frontend/src/store';
import closePopup from '~/frontend/src/actions/panelManager/closePopup';
import {
    panelClasses,
    PanelType,
    PanelClass
} from '~/frontend/src/components/base/page/PageTabPanel/definitions';
import {getPanelProps} from '~/frontend/src/components/base/page/PageTabPanel/utilities';
import {PANELMANAGER_CLOSE_POPUP} from '~/frontend/src/constants';


/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 */
const saveAndClosePopup = ( panelKey : string ) : Thunk<Promise<void>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<void> => {
    const panelProps          = getPanelProps( panelKey )?.panelProps,
          panelType           = panelProps?.panelType,
          PanelComponentClass = panelType ? panelClasses[ panelType as PanelType ] as unknown as PanelClass : undefined;

    let saveResult:boolean = true;

    // has panel a close action -> dispatch it
    if ( PanelComponentClass?.onSavePanelAction ) {
        saveResult = await dispatch( PanelComponentClass.onSavePanelAction( { ...panelProps, uid: panelKey } ) );
    }

    if ( saveResult ) {
        await dispatch( closePopup( panelKey ) );
    }
};
export type SaveAndClosePopup = typeof saveAndClosePopup;

export default saveAndClosePopup;
